export default __webpack_public_path__ + "static/preview-e836109743a2a542a850f9c7d858deee.png";